var _path, _circle, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09582 8.69691C4.12193 8.50616 4.21645 8.33548 4.3533 8.19986L8.30145 4.28713C8.69246 3.89963 9.32353 3.90049 9.71347 4.28907L13.7073 8.28448C14.097 8.67283 14.0995 9.30258 13.7129 9.694L11.0142 12.4419C11.0142 12.4419 10.6127 15.7259 13.4437 18.5531C16.2747 21.3803 19.6235 20.9695 19.6235 20.9695L22.3051 18.2854C22.696 17.8941 23.3308 17.8939 23.7219 18.2851L27.7213 22.2848C28.1118 22.6754 28.1114 23.3082 27.7203 23.6983L23.7417 27.6669C23.6057 27.8026 23.4347 27.8962 23.2441 27.9214C21.8862 28.1014 15.9491 28.4591 9.73622 22.2546C3.51972 16.0465 3.90908 10.0613 4.09582 8.69691Z",
    stroke: "current",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14,
    r: 1,
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 14C23 11.2386 20.7614 9 18 9",
    stroke: "current",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 8.47715 23.5228 4 18 4",
    stroke: "current",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.33750b02.svg";
export { ForwardRef as ReactComponent };